import React, { useEffect } from 'react'
import { Button, Card, CardBody, CardTitle, Col, Form, Input, Label, Row, FormFeedback } from "reactstrap";
import * as yup from "yup";
import { useFormik } from "formik";
import { updateAdminSettings } from 'helpers/API Calls/System & Settings/Admin Settings';

function Stripe({data}: any) {
  const formik = useFormik({
    initialValues: {
      enableStripe: false,
      stripeSecretKey: '',
      stripePublicKey: '',
    },    
    validationSchema: yup.object().shape({
      enableStripe: yup.boolean(),
      stripeSecretKey: yup.string(),
      stripePublicKey: yup.string().when(['enableStripe'], {
        is: true,
        then: () => yup.string().required('Stripe public key is required')
      }),
    }),
    onSubmit: async (values: any, { setSubmitting }) => {
      setSubmitting(true);
      try{
        const reqData = [
        {
          key: "STRIPE_PAYMENT",
          value: values.enableStripe ? 'ENABLED' : 'DISABLED',
          id: data.STRIPE_PAYMENT.id,
        }, 
        
      ];
      if (values.enableStripe && values.stripeSecretKey) {
        reqData.push({
          key: "STRIPE_SECRET",
          value: values.stripeSecretKey,
          id: data.STRIPE_SECRET.id,
        });
      }
      if (values.enableStripe && values.stripePublicKey) {
        reqData.push({
          key: "STRIPE_PUBLIC_KEY",
          value: values.stripePublicKey,
          id: data?.STRIPE_PUBLIC_KEY?.id,
        });
      }
      const response = await updateAdminSettings({'settings' : reqData});
      if (response) {
        setSubmitting(false);
      }
      }
      catch (error) {
        console.error("Error updating settings:", error);
        setSubmitting(false);
      }
    }
  });  

  useEffect(() => {
    if (data) {
      formik.setValues({
        enableStripe: data?.STRIPE_PAYMENT?.value === 'ENABLED',
        stripeSecretKey: data?.STRIPE_SECRET?.value || '',
        stripePublicKey: data?.STRIPE_PUBLIC_KEY?.value || '',
      });
    }
  }, [data]);

  // Add scroll to error effect
  useEffect(() => {
    if (Object.keys(formik.errors).length > 0 && formik.isSubmitting) {
      const firstErrorKey = Object.keys(formik.errors)[0];
      const element = document.getElementById(firstErrorKey);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        element.focus();
      }
    }
  }, [formik.errors, formik.isSubmitting]);
      
  return (
    <Card>
      <CardBody>
        <CardTitle tag="h4" className='mb-4'>Stripe Settings</CardTitle>
        <Form onSubmit={formik.handleSubmit} autoComplete="off">
          <div className="mb-4">
            <div className="mb-3">
              <div className="form-check">
                <Input
                  type="checkbox"
                  className="form-check-input"
                  id="enableStripe"
                  name="enableStripe"
                  checked={formik.values.enableStripe}
                  onChange={formik.handleChange}
                />
                <Label className="form-check-label" htmlFor="enableStripe">
                  Enable Stripe Payments
                </Label>
              </div>
            </div>

            {formik.values.enableStripe && (
              <Row>
                <Col sm="6">
                  <div>
                    <Label htmlFor="stripePublicKey">Stripe Public Key <span className="text-danger">*</span></Label>
                    <Input
                      id="stripePublicKey"
                      name="stripePublicKey"
                      type="text"
                      value={formik.values.stripePublicKey}
                      onChange={formik.handleChange}
                      invalid={formik.touched.stripePublicKey && formik.errors.stripePublicKey ? true : false}
                      disabled={data?.STRIPE_PUBLIC_KEY?.can_update !== 1}
                    />                        
                    {formik.errors.stripePublicKey && formik.touched.stripePublicKey && (
                      <FormFeedback type="invalid">{String(formik.errors.stripePublicKey)}</FormFeedback>
                    )}
                  </div>
                </Col>
                <Col sm="6">
                  <div>
                    <Label htmlFor="stripeSecretKey">Stripe Secret Key</Label>
                    <Input
                      id="stripeSecretKey"
                      name="stripeSecretKey"
                      type="password"
                      value={formik.values.stripeSecretKey}
                      onChange={formik.handleChange}
                      invalid={formik.touched.stripeSecretKey && formik.errors.stripeSecretKey ? true : false}
                      // disabled={data?.STRIPE_SECRET?.can_update !== 1}
                    />                        
                    {formik.errors.stripeSecretKey && formik.touched.stripeSecretKey && (
                      <FormFeedback type="invalid">{String(formik.errors.stripeSecretKey)}</FormFeedback>
                    )}
                  </div>
                </Col>
              </Row>
            )}
          </div>

          <div className="d-flex flex-wrap gap-2 justify-content-end">
            <Button type="submit" color="primary" disabled={formik.isSubmitting}>
              {formik.isSubmitting ? 'Saving...' : 'Save Settings'}
            </Button>
          </div>
        </Form>
      </CardBody>
    </Card>
  );
}

export default Stripe;
